var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    class: _vm.$style.loading
  }, [!_vm.error ? _c('BaseIcon', {
    attrs: {
      "name": "spinner",
      "spin": ""
    }
  }) : _vm._e(), _vm.error ? _c('p', [_vm._v(_vm._s(_vm.errorMessage || "There was an error loading this page. Please, try again later."))]) : _vm._e()], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }